import { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useContactUsHandler } from '../../../../hooks';

export const useOpenChatFromHomeScreen = () => {
  const params = useLocalSearchParams<HomeScreenParams>();
  const router = useRouter();
  const { handleContactUs } = useContactUsHandler('home');

  return useCallback(() => {
    // Search params are strings, so a stale `?chat=false` is still truthy.
    const hasChatRequest = Boolean(params?.chat) && params?.chat !== 'false';

    if (!hasChatRequest) {
      return;
    }

    router.setParams({ chat: undefined });
    void handleContactUs();
  }, [params?.chat, router, handleContactUs]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type HomeScreenParams = {
  chat?: string;
};
